import React from "react";
import moment from "moment";
import { theme, fmtRelative } from "../theme";
import { useCurrencyFormatter } from "../../../../Components/Hooks/useCurrencyFormatter";

const ContractOverdueAlert = ({ contract }) => {
  const { formatCurrency } = useCurrencyFormatter();
  const today = moment().startOf("day");

  const overduePayments = (contract?.payments || []).filter(
    (p) => !p.cashed && p.booking_date && moment(p.booking_date).isBefore(today)
  );

  if (overduePayments.length === 0) return null;

  const total = overduePayments.reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);

  const text =
    overduePayments.length === 1
      ? `${overduePayments[0].type} of ${formatCurrency(overduePayments[0].amount, "EUR")} was due ${moment(
          overduePayments[0].booking_date
        ).format("D MMM YYYY")} — ${fmtRelative(today.diff(moment(overduePayments[0].booking_date), "days"))} late.`
      : `${overduePayments.length} payments totalling ${formatCurrency(total, "EUR")} are past their due date.`;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "12px 16px",
        border: `1px solid ${theme.dangerBadgeBg}`,
        background: theme.dangerBg,
        borderRadius: 12,
        marginBottom: 22,
        flexWrap: "wrap",
      }}
    >
      <span
        style={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: "0.5px",
          textTransform: "uppercase",
          color: theme.dangerText,
          background: theme.dangerBadgeBg,
          padding: "3px 8px",
          borderRadius: 5,
        }}
      >
        {overduePayments.length === 1 ? "Payment overdue" : `${overduePayments.length} payments overdue`}
      </span>
      <span style={{ fontSize: 13.5, color: theme.dangerText, flex: 1, minWidth: 200 }}>{text}</span>
    </div>
  );
};

export default ContractOverdueAlert;
